import { Pipe, PipeTransform } from '@angular/core';
import { StatusParcelaEnum } from '../shared/enums/status-parcela.enum';
@Pipe({
  name: 'statusParcelaText'
})
export class StatusParcelaTextPipe implements PipeTransform {

  transform(statusParcela: StatusParcelaEnum): string {
    return (() => {
      switch (statusParcela) {
        case StatusParcelaEnum.STATUS_EM_DIA: return 'Em dia';
        case StatusParcelaEnum.STATUS_PAGO: return 'Pago';
        case StatusParcelaEnum.STATUS_VENCIDA: return 'Vencida';
        // Caso seja STATUS_ACORDO_RENEGOCIADO ou STATUS_ACORDO_RENEGOCIADO, retornara o status vencida,
        // decisão da squad porque faz mais sentido para usuário visualizar assim
        case StatusParcelaEnum.STATUS_ACORDO_RENEGOCIADO: return 'Vencida';
        case StatusParcelaEnum.STATUS_FORA_RANGE_ACORDO: return 'Vencida';
        default: return 'Pendente';
      }
    })();
  }
}
